import React from "react";

const RichText = ({ block }) => (
  <section>
    <div className="shell">
      <div className="prose max-w-none mb-8 body-content-rich-text-bullets" dangerouslySetInnerHTML={{ __html: block.richText, }}/>
    </div>
  </section>
);

export default RichText;